import { createAction } from 'typesafe-actions'

export const setActiveRenderImgIdx = createAction('CMD / renderImages / set active idx')<number>()

export const setActiveRenderImgIdxState = createAction('DOC / renderImages / set active idx state')<number>()

export const resetActiveRenderImgIdx = createAction('DOC / renderImages / reset active idx')<void>()
